enum CostUnitSourceEnum {
  ASSESSMENT = 'assessment',
  ESTIMATE = 'estimate',
  INVOICE = 'invoice',
  OTHER = 'other'
}

export default CostUnitSourceEnum;
